import _implicitStylesheets from "./securityReviewRaiseAChallenge.css";
import _implicitScopedStylesheets from "./securityReviewRaiseAChallenge.scoped.css?scoped=true";
import _c360Icon from "c360/icon";
import _appxInputWrapper from "appx/inputWrapper";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span data-test-id="returned-disagree" class="disagree-message${0}"${2}>${"t1"}</span>`;
const $fragment2 = parseFragment`<div${3}><a class="a-link${0}"${2}>${"t2"}</a></div>`;
const $fragment3 = parseFragment`<div class="slds-col slds-size_1-of-12${0}"${2}></div>`;
const $fragment4 = parseFragment`<div class="subtitle instruction-text slds-size_11-of-12 slds-col${0}"${2}><span data-test-id="returned-disagree-instructions" class="disagree-message${0}"${2}>${"t2"}</span></div>`;
const $fragment5 = parseFragment`<div class="subtitle after-details-text slds-size_11-of-12 slds-col${0}"${2}><span data-test-id="resubmit" class="disagree-message${0}"${2}>${"t2"}</span><span class="a-link${0}"${2}>${"t4"}</span></div>`;
const stc0 = {
  classMap: {
    "raise-a-challenge": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "slds-grid": true,
    "slds-wrap": true,
    "slds-p-top_medium": true
  },
  key: 1
};
const stc2 = {
  classMap: {
    "slds-size_1-of-12": true,
    "slds-col": true
  },
  key: 2
};
const stc3 = {
  props: {
    "size": "x-small",
    "iconName": "utility:engage",
    "iconClass": "normal"
  },
  key: 3
};
const stc4 = {
  classMap: {
    "subtitle": true,
    "slds-size_11-of-12": true,
    "slds-col": true
  },
  key: 4
};
const stc5 = {
  classMap: {
    "slds-form-element": true,
    "text-input": true,
    "slds-col": true,
    "slds-size--11-of-12": true
  },
  key: 11
};
const stc6 = {
  "data-test-id": "raise-a-challenge-text"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, h: api_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, b: api_bind, gid: api_scoped_id} = $api;
  const {_m0, _m1} = $ctx;
  return [$cmp.showRaiseAChallenge ? api_element("div", stc0, [api_element("div", stc1, [api_element("div", stc2, [api_custom_element("c360-icon", _c360Icon, stc3)]), api_element("div", stc4, [api_static_fragment($fragment1, 6, [api_static_part(1, null, api_dynamic_text($cmp.labels.returnedDisagree))]), !$cmp.showDetails ? api_static_fragment($fragment2, 8, [api_static_part(1, {
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleShowDetails))
    }
  }, null), api_static_part(2, null, api_dynamic_text($cmp.labels.requestSecondLook))]) : null]), $cmp.showDetails ? api_static_fragment($fragment3, 10) : null, $cmp.showDetails ? api_element("div", stc5, [api_static_fragment($fragment4, 13, [api_static_part(2, null, api_dynamic_text($cmp.labels.secondLookInstructions))]), api_custom_element("appx-input-wrapper", _appxInputWrapper, {
    attrs: stc6,
    props: {
      "type": "textArea",
      "ariaLabelledBy": api_scoped_id("raiseAChallengeLabel"),
      "maxLength": $cmp.challengeSchema.challenge.maxLength,
      "value": $cmp.challengeText,
      "changeCallback": $cmp.onChangeRaiseAChallenge,
      "showRemainingCharacters": true,
      "placeholder": $cmp.sharedLabels.textAreaPlaceholder,
      "widthClass": "slds-size--5-of-6"
    },
    key: 14
  }), api_static_fragment($fragment5, 16, [api_static_part(2, null, api_dynamic_text($cmp.labels.afterDetails)), api_static_part(3, {
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.handleResubmit))
    }
  }, null), api_static_part(4, null, api_dynamic_text($cmp.labels.resubmit))])]) : null])]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-578i5r059kd";
tmpl.legacyStylesheetToken = "appx-securityReviewRaiseAChallenge_securityReviewRaiseAChallenge";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
